import { useData, useDispatch } from "./DataContext.js";
import { getSimParam, setSimParam } from "./utils.js";

import Title from "./Title.js";
import ArticleCard from "./ArticleCard.js";
import ToggleButton from "react-bootstrap/ToggleButton";

export default function SimArticleList ()
{
    const gData = useData();
    const gDispatch = useDispatch();

    const personal = getSimParam(gData, "personalArticles");
    function setPersonal () { setSimParam(gData, gDispatch, "personalArticles", true); }
    function unsetPersonal () { setSimParam(gData, gDispatch, "personalArticles", false); }
    function togglePersonal () { if (personal) unsetPersonal(); else setPersonal(); }

    const selectedArticleList = Object
	.entries(gData.article)
	.filter(([id, article]) => {
	    return article.simID === gData.simID
		&& (article.sessionNum === null || article.sessionNum === gData.sim[gData.simID].sessionNum)
		&& gData.article[article.firstArticleID].selected === 1;
	})
	.sort(([id1, article1], [id2, article2]) => { return article1.rank - article2.rank; })
	.map(([id, article], index) => { return (<ArticleCard key={article.rank} articleID={article.articleID}/>); });
    
    const unselectedArticleList = Object
	.entries(gData.article)
	.filter(([id, article]) => {
	    return article.simID === gData.simID
		&& (article.sessionNum === null || article.sessionNum === gData.sim[gData.simID].sessionNum)
		&& gData.article[article.firstArticleID].selected === 0;
	})
	.sort(([id1, article1], [id2, article2]) => { return article1.rank - article2.rank; })
	.map(([id, article]) => (<ArticleCard key={article.rank} articleID={article.articleID}/>));
    
    return (
	<div className="d-flex flex-column gap-5">
	    <div>
		{selectedArticleList.length === 0 ? (<Title>Aucun article sélectionné</Title>) : (<Title>Liste des articles</Title>)}
		<div className="w-100 d-flex flex-column align-items-center gap-3">{selectedArticleList}</div>
	    </div>
	    <div>
		<div className="w-100 text-center">
		    <ToggleButton type="checkbox" variant="outline-primary" checked={personal} onClick={togglePersonal}>Personnaliser la liste des articles</ToggleButton>
		</div>
		{personal && (
		    <>
			{unselectedArticleList.length === 0 ? (<Title>Aucun article en réserve</Title>) : (<Title>Article{unselectedArticleList.length > 1 ? "s" : ""} en réserve</Title>)}
			<div className="d-flex justify-content-center flex-wrap gap-3">{unselectedArticleList}</div>
		    </>
		)}
	    </div>
	</div>
    );
}
